import React from 'react'
import LayersMenu from './BottomBar/LayersMenu';
import LayerToolsRightBar from './LayerToolsRightBar';
import TopDateBar from './TopDateBar';
import useLeafletLayerManager from 'hooks/useLeafletLayerManager';
import { getDateAsStringArray } from 'utils/dateFunctions';
import { useNotificationHandler } from 'hooks/useNotificationHandler';
import useSearchParamsManager from 'hooks/useSearchParamsManager';

const MapUI = ({
    startDate, isDatePickerDisabled, enabledDates, setStartDate, predictionDayProps,
    isButtonClicked, onClick, mapRef, mapParameters, setMapParameters, layerRefs, opacities, setOpacities
}) => {

    const { openNotification, handleError } = useNotificationHandler();
    const { clearLeafletLayers, addLeafletLayer, createLeafletLayer } = useLeafletLayerManager();
    const { setStartDateUrlParam } = useSearchParamsManager();

    const updatePredictionDay = async (newDay) => {

        // We change the prediction day and map parameters.
        predictionDayProps.setPredictionDay(newDay);
        const newMapParameters = mapParameters.map((layerParameters) => ({
            ...layerParameters,
            predictionDay: newDay
        }));
        setMapParameters(newMapParameters);

        // We refresh the layers, using the updated map parameters.
        const { selectedDay, selectedMonth, selectedYear } = getDateAsStringArray(startDate);
        clearLeafletLayers(mapRef, layerRefs);
        newMapParameters.map(async (layerParameters, index) => {
            const newLayer = await createLeafletLayer(layerParameters, selectedDay, selectedMonth, selectedYear, opacities[index], openNotification, handleError);
            addLeafletLayer(newLayer, mapRef, layerRefs);
        });

    };

    const updateDate = (date) => {
        if (!date || date == startDate) return;
        
        setStartDate(date);
        setStartDateUrlParam(date);
        
        let newMapParameters = mapParameters;
        if(predictionDayProps.predictionDay != 0) { // Resetting the prediction day if it's changed.
            newMapParameters = mapParameters.map((layerParameters) => ({ 
                ...layerParameters, predictionDay: 0 
            }));

            predictionDayProps.setPredictionDay(0);
            setMapParameters(newMapParameters);
        }

        // We refresh the layers, using the same map parameters.
        const { selectedDay, selectedMonth, selectedYear } = getDateAsStringArray(date);
        clearLeafletLayers(mapRef, layerRefs);
        newMapParameters.map(async (layerParameters, index) => {
            const newLayer = await createLeafletLayer(layerParameters, selectedDay, selectedMonth, selectedYear, opacities[index], openNotification, handleError);
            addLeafletLayer(newLayer, mapRef, layerRefs);
        });
    };

    return (
        <div id="map-ui">

            <TopDateBar
                startDate={startDate}
                setStartDate={setStartDate}
                isDatePickerDisabled={isDatePickerDisabled}
                enabledDates={enabledDates}
                predictionDayProps={predictionDayProps}
                mapRef={mapRef}
                layerRefs={layerRefs}
                updatePredictionDay={updatePredictionDay}
                updateDate={updateDate}
            />

            <LayerToolsRightBar
                isButtonClicked={isButtonClicked}
                onClick={onClick}
                mapRef={mapRef}
            />

            <LayersMenu
                mapParameters={mapParameters}
                setMapParameters={setMapParameters}
                layerRefs={layerRefs}
                mapRef={mapRef}
                enabledDates={enabledDates}
                opacities={opacities}
                setOpacities={setOpacities}
            />

        </div>
    );
}

export default MapUI;